<template>
  <div class="brand-logo">
    <svg class="brand-mark" viewBox="0 0 64 64" aria-hidden="true">
      <defs>
        <linearGradient :id="gid" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stop-color="#33e2c7" />
          <stop offset="1" stop-color="#4b86ff" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="60" height="60" rx="15" :fill="`url(#${gid})`" />
      <g stroke="#1e3a8a" stroke-width="0.9" stroke-linejoin="round">
        <polygon points="32,17 45.86,25 32,33 18.14,25" fill="#ffffff" />
        <polygon points="18.14,25 32,33 32,49 18.14,41" fill="#ffffff" fill-opacity="0.82" />
        <polygon points="45.86,25 45.86,41 32,49 32,33" fill="#ffffff" fill-opacity="0.6" />
      </g>
    </svg>
    <span class="brand-name">Pool</span>
  </div>
</template>

<script>
export default {
  name: "BrandLogo",
  data() {
    return {
      // 唯一的渐变 id，避免多实例时 SVG defs 冲突
      gid: `poolBrand_${Math.random().toString(36).slice(2, 8)}`,
    };
  },
};
</script>

<style scoped>
.brand-logo {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.brand-mark {
  width: 26px;
  height: 26px;
  display: block;
}

.brand-name {
  font-size: 26px;
  font-weight: 700;
  line-height: 1;
  color: var(--pool-text);
  letter-spacing: 0.5px;
}
</style>
